module.exports = __webpack_public_path__ + "img/logo27.c715bfff.jpg";